<template>
  <div class="p-5 flex flex-col h-full">
    <div class="border-dotted border-2 h-20 overflow-auto">
      <el-tag
        v-for="item in selectedList"
        :key="`${item.type}-${item.id}`"
        disable-transitions
        closable
        @close="handleCloseTag(item)"
      >
        <i :class="[{ 'el-icon-user-solid text-red-500' : (item.type === 'user'), 'bi-diagram-3-fill text-yellow-500' : (item.type === 'department'), 'bi-person-workspace text-blue-500' : (item.type === 'role'), 'bi-person-lines-fill text-green-500' : (item.type === 'dynamic')}, 'pr-1 text-lg']" />
        <span class="text-sm text-black">{{ item.name }}</span>
      </el-tag>
    </div>
    <div class="border h-3/4 mt-2 member-list">
      <el-tabs :active-name="tabs[0]">
        <el-tab-pane v-if="tabs.includes('department')" label="组织架构" name="department">
          <div class="flex flex-grow w-full h-full">
            <el-tree
              :default-expanded-keys="departments.length > 0 ? [departments[0].id] : []"
              highlight-current class="w-full" node-key="id" :data="departments"
              :expand-on-click-node="false" @node-click="handleNodeClick($event, 'department')"
            >
              <span slot-scope="{ node, data }" class="group w-full">
                <div class="flex justify-between">
                  {{ data.name }}
                  <span class="pr-2" @click.stop>
                    <el-radio v-if="single" v-model="data.selected" :label="true"><br /></el-radio>
                    <el-checkbox v-else v-model="data.selected" />
                  </span>
                </div>
              </span>
            </el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="tabs.includes('role')" label="角色" name="role">
          <el-tree
            highlight-current class="dept_tree w-full" node-key="id" :data="roles"
            :expand-on-click-node="false" @node-click="handleNodeClick($event, 'role')"
          >
            <span slot-scope="{ node, data }" class="group w-full">
              <div class="flex justify-between">
                {{ data.name }}
                <span class="pr-2" @click.stop>
                  <el-radio v-if="single" v-model="data.selected" :label="true"><br /></el-radio>
                  <el-checkbox v-else v-model="data.selected" />
                </span>
              </div>


            </span>
          </el-tree>
        </el-tab-pane>
        <el-tab-pane v-if="tabs.includes('user')" label="成员" name="user">
          <div class="flex flex-grow w-full h-full  overflow-y-auto">
            <div class="w-1/2 border-r  h-full overflow-auto">
              <el-tree
                :default-expanded-keys="departments.length > 0 ? [departments[0].id] : []"
                highlight-current class="dept_tree" node-key="id" :data="departmentsWithRoot"
                :expand-on-click-node="false" @node-click="handleMemberSelect"
              >
                <span slot-scope="{ node, data }" class="group w-full">
                  {{ data.name }}
                </span>
              </el-tree>
            </div>
            <div class="w-1/2 h-full flex flex-col justify-between">
              <div class=" overflow-y-auto">
                <el-tree
                  highlight-current node-key="id" :data="members"
                  :expand-on-click-node="false" @node-click="handleNodeClick($event, 'user')"
                >
                  <span slot-scope="{ node, data }" class="w-full flex justify-between">
                    {{ data.nickname }}
                    <span class="pr-2" @click.stop>
                      <el-radio v-if="single" v-model="data.selected" :label="true"><br /></el-radio>
                      <el-checkbox v-else v-model="data.selected" />
                    </span>
                  </span>
                </el-tree>
              </div>

              <div class="text-right">
                <el-pagination
                  hide-on-single-page
                  :page-size="listMemberQuery.per_page"
                  :total="memberTotal"
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="tabs.includes('dynamic')" label="动态参数" name="dynamic">
          <div class="flex flex-grow w-full h-full">
            <el-tree
              highlight-current class="w-full" node-key="id" :data="dynamic"
              :expand-on-click-node="false" @node-click="handleNodeClick($event, 'dynamic')"
            >
              <span slot-scope="{ node, data }" class="w-full flex justify-between">
                {{ data.name }}
                <span class="pr-2" @click.stop>
                  <el-radio v-if="single" v-model="data.selected" :label="true"><br /></el-radio>
                  <el-checkbox v-else v-model="data.selected" />
                </span>
              </span>
            </el-tree>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="mt-4 flex h-10 justify-end">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm">确认</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import zroute from '../ziggy'
import {formatToTree} from '../utils'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    single: {
      type: Boolean,
      default: false,
    },
    tabs: {
      type: Array,
      default: () => [
        'department',//组织架构
        'role',//角色
        'user',//成员
        // 'dynamic',//动态负责人
      ],
    },
  },
  data() {
    return {
      dynamic_type: 'flow',
      radio: '',
      selectedList: this.value ? this.value : [],
      departments: [],
      roles: [],
      members: [],
      dynamic: [
        {
          id: '1', name: '流程发起人', type: 'flow',//流程选择
        },
        {
          id: '2', name: '发起人直接部门主管', type: 'flow',
        },
        {
          id: '3', name: '发起人上级部门主管', type: 'flow',
        },
        {
          id: '4', name: '发起人三级部门主管', type: 'flow',
        },
        {
          id: '5', name: '发起人四级部门主管', type: 'flow',
        },
        {
          id: '6', name: '发起人五级部门主管', type: 'flow',
        },
        {
          id: 'current_user', name: '当前用户', type: 'user',//用户选择默认值
        },
        {
          id: 'current_dept', name: '当前用户所处的部门', type: 'dept',//用户选择默认值
        },
        {
          id: 'current_parent_dept', name: '当前用户所处的上级部门', type: 'dept',//用户选择默认值
        },
      ].filter(item => this.tabs.includes('dynamic_' + item.type)),
      dynamic_items: [],
      listMemberQuery: {
        role_id: 0,
        page: 1,
        per_page: 10,
        type: 'department',
        department_id: 0,
      },
      memberTotal: 0,
    }
  },
  computed: {
    departmentsWithRoot: function () {
      return [{id: 0, name: '全部成员', children: this.departments}]
    },
  },
  watch: {
    departments: {
      handler(val) {
        // console.log('departments change', val)
        this.buildSelectedList(val, 'department')

      },
      deep: true,
    },
    roles: {
      handler(val) {
        // console.log('roles change', val)
        this.buildSelectedList(val, 'role')
      },
      deep: true,
    },
    members: {
      handler(val) {
        // console.log('members change', val)
        this.buildSelectedList(val, 'user')

      },
      deep: true,
    },
    dynamic: {
      handler(val) {
        // console.log('dynamic change', val)
        this.buildSelectedList(val, 'dynamic')

      },
      deep: true,
    },
  },
  created() {
    if (this.tabs.indexOf('department') > -1 || this.tabs.indexOf('user') > -1) {
      this.getDepartments()
    }
    if (this.tabs.indexOf('role') > -1) {
      this.getRoles()
    }
    if (this.tabs.filter(item => item.indexOf('dynamic_') > -1).length > 0) {
      this.tabs.push('dynamic')
    }
    // console.log('member list created', this.value)
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onConfirm() {
      this.$emit('input', this.selectedList)
    },
    handleCloseTag(tag) {
      // console.log('handleCloseTag', tag)
      this.selectedList = this.selectedList.filter(i => !(i.type === tag.type && i.id === tag.id))
      let fn = function (item) {
        if (item.id === tag.id) {
          item.selected = false
        }
        if (item.children) {
          item.children.forEach(i => fn(i))
        }
        return item
      }
      if (tag.type === 'department') {
        this.departments = this.departments.map(fn)
      } else if (tag.type === 'role') {
        this.roles = this.roles.map(fn)
      } else if (tag.type === 'user') {
        this.members = this.members.map(fn)
      } else if (tag.type === 'dynamic') {
        this.dynamic = this.dynamic.map(fn)
      }
      // this.$emit('input', this.value)
    },
    buildSelectedList(val, type) {
      // console.log('buildSelectedList', val, type)
      val.forEach(item => {
        let tag = {type: type, id: item.id, name: item.name}
        if (item.selected) {
          if (this.selectedList.filter(i => i.type === type && i.id === item.id).length === 0) {
            this.selectedList.push(tag)
          }
        } else {
          if (this.selectedList.filter(i => i.type === type && i.id === item.id).length > 0) {
            // this.selectedList.splice(this.selectedList.indexOf(tag), 1)
            this.selectedList = this.selectedList.filter(i => !(i.type === type && i.id === item.id))
          }
        }
        if (item.children) {
          this.buildSelectedList(item.children, type)
        }
      })
      // console.log('selectedList', this.selectedList)
      if (this.single) {
        if (this.selectedList.length > 1) {
          this.selectedList.slice(0, -1).map(i => {
            this.handleCloseTag(i)
          })
          this.selectedList = this.selectedList.slice(-1)

        }
      }

      // this.$emit('input', this.selectedList)

    },
    handleNodeClick(data, type) {
      this.$set(data, 'selected', !data.selected)
      if (type === 'dynamic') {
        this.dynamic = this.dynamic.map(item => {
          if (item.id === data.id) {
            item.selected = data.selected
          }
          return item
        })
      }
    },
    handleRoleSelect(data) {
      // console.log('role select', data)
      this.$set(data, 'selected', !data.selected)
      // this.$emit('input', this.value)

    },
    handleMemberSelect(data) {
      // console.log('member select', data)
      this.listMemberQuery.page = 1
      this.listMemberQuery.department_id = data.id
      this.getListMember()
    },
    treeLoop(item, type) {
      // console.log('treeLoop', item, this.selectedList)
      // console.log('------------------------------------')
      return item.map(i => {
        i.selected = this.selectedList.filter(s => s.type === type && s.id === i.id).length > 0
        if (i.children) {
          i.children = this.treeLoop(i.children, type)
        }
        return i
      })
    },
    getDepartments() {
      axios.get(zroute('contacts.departments')).then(response => {
        this.departments = this.treeLoop(formatToTree(response.data.departments), 'department')
      })
    },
    getListMember() {
      axios.get(zroute('contacts.list'), {
        params: this.listMemberQuery,
      }).then(res => {
        this.members = res.data.members.list.map(item => {
          item.selected = this.selectedList.filter(i => i.type === 'user' && i.id === item.id).length > 0
          item.name = item.nickname
          return item
        })
        this.memberTotal = res.data.members.total
      })
    },
    getRoles() {
      axios.get(zroute('contacts.roles')).then(response => {
        this.roles = this.treeLoop(response.data.roles, 'role')
      })
    },
    handleCurrentChange(val) {
      this.listMemberQuery.page = val
      this.getListMember()
    },
  },
}
</script>

<style lang="scss" scoped>
.el-tag {
  margin-left: 5px;
  margin-top: 5px;
}

.member-list {
  ::v-deep .el-tabs {
    height: 100%;

    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px;
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__content {
      height: calc(100% - 39px);

      .el-tab-pane {
        height: 100%;
      }
    }

  }
}

</style>
